export const CURRENT_COMPANY_STORAGE_KEY = "mbid.currentCompanyId";

export function isCompanyActive(company) {
  return company?.active !== false;
}

export function getWorkspaceCompanies(companies = []) {
  return (companies || []).filter(isCompanyActive);
}

export function shouldShowCompanyWorkspaceSwitcher(companies = []) {
  return getWorkspaceCompanies(companies).length > 1;
}

export function pickWorkspaceId(companies = [], storedId = "") {
  const active = getWorkspaceCompanies(companies);
  if (!active.length) return "";
  if (storedId && active.some((company) => company._id === storedId)) {
    return storedId;
  }
  const defaultCompany = active.find((company) => company.isDefault);
  if (defaultCompany) return defaultCompany._id;
  return active[0]._id || "";
}

export function getStoredCompanyId(storage = window.localStorage) {
  try {
    return storage.getItem(CURRENT_COMPANY_STORAGE_KEY) || "";
  } catch (error) {
    return "";
  }
}

export function setStoredCompanyId(companyId, storage = window.localStorage) {
  try {
    if (!companyId) {
      storage.removeItem(CURRENT_COMPANY_STORAGE_KEY);
      return;
    }
    storage.setItem(CURRENT_COMPANY_STORAGE_KEY, companyId);
  } catch (error) {
    // ignore quota / private-mode failures
  }
}

export function buildCompanyHeaders(headers = {}, companyId) {
  const next = { ...headers };
  if (companyId) {
    next["X-Company-Id"] = companyId;
  }
  return next;
}
